import * as React from 'react'
import ImageList from '@mui/material/ImageList'
import ImageListItem from './ImageListItem'

import Skeleton from '@mui/material/Skeleton'
import { Container } from '@mui/material'
import Stack from '@mui/material/Stack'

interface Props {
      items: Item[]
      loading?: boolean
      onItemSelect?: (id: number) => void
      handleDoubleClick?: (id: number) => void
}
interface Item {
      id: number
      src: string
      srcSet?: string
      title: string
      author: number
      featured?: boolean
      fullWidth?: boolean
      bottomRightButton?: any
      isSelected?: boolean
}
const EventList: React.FC<Props> = (props: Props) => {
      if (props.loading) {
            return (
                  <Container style={{ padding: '10px' }}>
                        <Stack spacing={1}>
                              {Array.from({ length: 6 }).map((item, index) => (
                                    <Stack
                                          key={index}
                                          style={{ width: '100%' }}
                                          direction="row"
                                          spacing={1}
                                    >
                                          {Array.from({ length: 3 }).map((item2, index2) => (
                                                <Skeleton
                                                      key={index2}
                                                      variant="rectangular"
                                                      width={'100%'}
                                                      height={100}
                                                      style={{ borderRadius: '14px' }}
                                                />
                                          ))}
                                    </Stack>
                              ))}
                        </Stack>
                  </Container>
            )
      }

      if (!props.items) return null
      return (
            <ImageList
                  sx={{
                        width: '100%',
                        height: '100%',
                        // Promote the list into its own layer in Chrome. This costs memory, but helps keeping high FPS.
                        transform: 'translateZ(0)',
                        overflowWrap: 'anywhere',
                  }}
                  cols={3}
                  rowHeight={110}
                  // rowHeight={window.innerWidth ? window.innerWidth / 3 - 40 : 100}
                  gap={7}
            >
                  {props.items.map((item) => {
                        return (
                              <ImageListItem
                                    key={item.id}
                                    {...item}
                                    isSelected={item.isSelected}
                                    isVideo={item.isVideo}
                                    onItemSelect={props.onItemSelect}
                                    handleDoubleClick={props.handleDoubleClick}
                              />
                        )
                  })}
            </ImageList>
      )
}

export default EventList
